import React from "react";
import { Form, Dropdown, DropdownButton, InputGroup } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { CHANGE_AVG_ENTRY_PRICE } from "../../../../actions/create-bot-type";
import TutorialPopup from "../../../help/TutorialPopup";

const SellBotEntryView = (props) => {
  const { newBot, isEntry,t } = props;
  const dispatch = useDispatch();
  const avgEntryPriceChanged = (val) => {
    dispatch({
      type: CHANGE_AVG_ENTRY_PRICE,
      payload: val,
    });
  };
  return (
    <>
      <Form.Label>
      {t("sell-bot-entry")}
      </Form.Label>

      <Form.Group>
        <Form.Label>
       {t("avg-entry-price")}<TutorialPopup content={t("avg-entry-help")} />
        
        </Form.Label>
            <InputGroup>
            <Form.Control
                as="input"
                type="number"
                placeholder="0"
                value={newBot.avgEntryPrice}
                onChange={(e) => {
                    avgEntryPriceChanged(e.target.value);
                }}
            ></Form.Control>
            <InputGroup.Append>
                <InputGroup.Text>{newBot.quoteCoin}</InputGroup.Text>
            </InputGroup.Append>
            </InputGroup>
    </Form.Group>
             
    </>
  );
};

export default connect(null)(SellBotEntryView);
